import { ChangeDetectorRef, Component } from '@angular/core';
import { Inspection } from '../../../shared/models/index';
import { PluginComponent } from '../../plugin.component';

@Component({
    templateUrl: './customer-contact.component.html',
    standalone: false
})
export class InstallationCustomerContactPluginComponent {
  public customerContacts: any[];
  public config: any;
  public editRoute = ['installation', 'customercontact', 'edit'];
  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.customerContacts = this.config.CustomerContacts;
  }
}

PluginComponent.plugins['installationcustomercontact'] = InstallationCustomerContactPluginComponent;
